import * as R from 'ramda';
import { MetaDataCategory } from 'types/api/envScales/MetaDataCategory';
import { CycleMetaDataValue } from 'types/api/envScales/CycleMetaDataValue';

export type OptionValue = {
  isChecked: boolean;
  choiceId: number;
  isPrimary: boolean;
};

export type SelectedValues = {
  [key: string]: OptionValue;
};

export function getInitialValues(
  category: MetaDataCategory,
  values: CycleMetaDataValue[]
) {
  let initialValues: SelectedValues = {};

  category.choices.forEach(choice => {
    const dbValue = values.find(
      value =>
        value.value === choice.t_name &&
        value.meta_data_category_id === category.id
    );

    initialValues[choice.t_name] = {
      choiceId: choice.id,
      isChecked: Boolean(dbValue),
      isPrimary: Boolean(dbValue?.is_primary)
    };
  });

  return initialValues;
}

type PayloadValue = {
  value: string;
  meta_data_choice_id: number;
  is_primary: boolean;
};

export function getPayloadValues(values: SelectedValues) {
  let payloadValues: PayloadValue[] = [];

  R.forEachObjIndexed((value, key) => {
    if (value.isChecked) {
      payloadValues = [
        ...payloadValues,
        {
          value: String(key),
          meta_data_choice_id: value.choiceId,
          is_primary: value.isPrimary
        }
      ];
    }
  }, values);

  return payloadValues;
}
